/**
 * Header Layout
 *
 * @file header.js
 */

import $ from "jquery";

const header = (() => {
  const mobileMenu = () => {
    $(".mobile-menu-button").on("click", function(){
      $(".mobile-menu-toggle").toggleClass("active");
    });
  };
  const searchB = () => {
    $(".header-right .search-box-bn").on("click", function(){
      $(this).next(".search-inp-box").toggleClass("active").find("input").focus();
    });
  };
  const mobileLeftMenu = () => {
    $(".mobile-menu-select").on("click", function(){
      $(this).next("nav").toggle();
    });
  };

  const init = () => {
    mobileMenu();
    searchB();
    mobileLeftMenu();
  };

  return {
    init,
  };
})();

export default header;
